<!-- 费用查询 -->
<template>
    <div class="el-expenseQuery">
        <el-row class="page_content">
            <h1 class="head_title">费用查询</h1>
            <el-form ref="form" :model="form" label-width="80px">
                <el-form-item label="年度">
                    <el-select v-model="form.region" :filterable="true" @change="selectScore" placeholder="请选择学期">
                        <el-option label="所有" value=""></el-option>
                        <el-option label="第一学年" value="1"></el-option>
                        <el-option label="第二学年" value="2"></el-option>
                        <el-option label="第三学年" value="3"></el-option>
                        <el-option label="第四学年" value="4"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <el-table
                :data="tableData"
                border
                style="width: 100%;">
                <el-table-column
                    prop="xq"
                    header-align="center"
                    align="center"
                    label="学年"
                    width="100">
                </el-table-column>
                <el-table-column
                    prop="title"
                    header-align="center"
                    align="center"
                    label="缴费年度">
                </el-table-column>
                <el-table-column
                    prop="title"
                    header-align="center"
                    align="center"
                    label="应缴费用">
                </el-table-column>
                <el-table-column
                    prop="title"
                    header-align="center"
                    align="center"
                    label="减免">
                </el-table-column>
                <el-table-column
                    prop="title"
                    header-align="center"
                    align="center"
                    label="实缴费用">
                </el-table-column>
                <el-table-column
                    prop="title"
                    header-align="center"
                    align="center"
                    label="欠费">
                </el-table-column>
            </el-table>
        </el-row>
    </div>
</template>
<script>
export default {
  name: "ExpenseQuery",
  data() {
    return {
        form:{
            region:""
        },
        tableData: []
    };
  },
  created() {
   
  },
  methods: {
    selectScore(v){
        console.log(v);
    },
    selectData(index){
        this.dialogVisible = true;
    }
  }
};
</script>
<style  lang="less">
  @import '../../styles/base.less';
  .el-expenseQuery{
    .wd{
        color: @red;
    }
    .el-dialog__body{
        border-top:1px solid #ebeef5;
    }
    .el-descriptions-item__container{
        font-size: 17px;
    }
    .el-descriptions-item__label {
        white-space: nowrap;
        width: 140px;
        text-align: right;
    }
    .el-descriptions-item__content{
        max-height: 200px;
        overflow: auto;
    }
  }
</style>


// WEBPACK FOOTER //
// src/pages/onlinePayment/ExpenseQuery.vue